import { render } from "./UserMenu.vue?vue&type=template&id=1fe7eb0b"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=1fe7eb0b&lang=css"
script.render = render

export default script